import * as Sfx from "redux-saga/effects";
import {parseBetOffer} from "@atg-sport-shared/sportsbook-utils-parsers";
import {
    type WapiBetOffersReceivedAction,
    WAPI_BET_OFFERS_RECEIVED,
    setWapiBetOffers,
} from "@atg-sport-shared/sportsbook-data-access-bet-offer";
import * as eventSelectors from "@atg-sport-shared/sportsbook-data-access-event";

export function* parseEventBetOffers(
    action: WapiBetOffersReceivedAction,
): Generator<Sfx.Effect, void, any> {
    const {betOffers} = action;
    const eventSelector = eventSelectors.createEventSelector();

    const event = yield Sfx.select(eventSelector, betOffers[0].eventId);

    if (!event) return;

    const {homeName, awayName} = event;
    const parsedBetOffers = betOffers.map((betOffer) =>
        parseBetOffer({homeName, awayName}, betOffer),
    );
    yield Sfx.put(setWapiBetOffers(parsedBetOffers));
}

export function* wapiSaga(): Generator<Sfx.Effect, void, any> {
    yield Sfx.takeLatest([WAPI_BET_OFFERS_RECEIVED], parseEventBetOffers);
}
